import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "file-finger--sprite",
  "use": "file-finger--sprite-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"file-finger--sprite\">\n<path d=\"M7.88021 13.5433H1.88021C1.14688 13.5433 0.546875 12.9433 0.546875 12.21V1.54329C0.546875 0.809961 1.14688 0.209961 1.88021 0.209961H7.21354L11.2135 4.20996V8.20996H9.88021V4.87663H6.54688V1.54329H1.88021V12.21H7.88021V13.5433ZM10.5469 13.3166V11.8233L12.5135 13.79L13.4535 12.85L11.4869 10.8766H12.9802V9.54329H9.21354V13.3166H10.5469Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol